/**
 * @param {string} messageId
 * @returns {boolean}
 */
export function messageExists(messageId) {
  const message = /** @type {HTMLElement | null} */ (
    document.getElementById(messageId)
  )
  return !!message
}
